import React from "react";
import { Text, Font, View, StyleSheet } from "@react-pdf/renderer";
import { DaftarKategoriListInvoice } from "../../constants/types";

Font.register({
    family: "Open-Sans-Bold",
    src: "https://fonts.gstatic.com/s/opensans/v34/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1y4nY1M2xLER.ttf",
});


interface IPrintStrukA4TotalQtyKategoriProps {
    category?: DaftarKategoriListInvoice[];
}

const styles = StyleSheet.create({
    row: {
        flexDirection: "row",
        alignItems: "center",
        fontFamily: "Open-Sans-Bold",
        borderLeftColor: "#fff",
        borderLeftWidth: 1,
        borderRightColor: "#000",
        borderRightWidth: 1,
        fontSize: 11,
    },
    description: {
        width: "60%",
        textAlign: "right",
        borderRightColor: "#000",
        borderRightWidth: 1,
        paddingHorizontal: 8,
        height: 18,
    },
    subtotalText: {
        width: "20%",
        textAlign: "right",
        borderBottomColor: "#000",
        borderBottomWidth: 1,
        borderRightColor: "#000",
        borderRightWidth: 1,
        paddingHorizontal: 8,
        height: 18,
    },
    subtotal: {
        width: "20%",
        textAlign: "right",
        borderBottomColor: "#000",
        borderBottomWidth: 1,
        paddingHorizontal: 8,
        height: 18,
    },
});

const PrintStrukA4TotalQtyKategori = ({ category }: IPrintStrukA4TotalQtyKategoriProps) => {

    if (!category || category.length === 0) {
        return null;
    }

    const totalQty = category.reduce((acc, curr) => {
        const qtyForCategory = curr.items.reduce((qtyAcc, item) => {
            return qtyAcc + item.jumlahItem;
        }, 0);
        return acc + qtyForCategory;
    }, 0);

    return (
        <View style={styles.row}>
            <Text style={styles.description}> </Text>
            <Text style={styles.subtotalText}>Total Qty</Text>
            <Text style={styles.subtotal}>{totalQty}</Text>
        </View>
    );
};

export default PrintStrukA4TotalQtyKategori;
